export const HOME_PAGE_URL = '/v1';
export const ALL_PLACES_PAGE_URL = '/boba-tea-places';
export const TOP_PLACES_URL = '/top';
export const NEW_PLACES_URL = '/new';
export const MAP_PAGE_URL = '/map';
export const BLOG_URL = '/blog';
export const ORDER_URL = '/order';
export const BOBA_TEA_PLACE_URL = '/boba-tea/:name';
export const ABOUT_US_URL = '/about-us'